import React from "react";
import Loading from "../../../../../ReusableFunctions/Loader";
import Popup from "../../../../../ReusableFunctions/Popup";
import Modal from "../../../../../ReusableComponents/Modal";
import Form from "../../../../../ReusableComponents/Form";
import InputField from "../../../../../ReusableComponents/InputField";
import { Button } from "../../../../../Components/Helper";
import SelectField from "../../../../../ReusableComponents/SelectField";
import { updateDspCurrency } from "../../../../../apis/users";

const EditCurrency = ({ open, onClose, dsp, onUserUpdate }) => {
  const currencyList = [
    { label: "Indian Rupee (INR)", value: "INR" },
    { label: "Moroccan Dirham (MAD)", value: "MAD" },
    { label: "US Dollar (USD)", value: "USD" },
    { label: "Euro (EUR)", value: "EUR" },
    { label: "British Pound (GBP)", value: "GBP" },
  ];
  const EditCurrencyData = async (dspDetails) => {
    console.log("Received from form:", dspDetails);
    if (dspDetails?.invoice_currency && dspDetails.id) {
      try {
        Loading.set(true);
        const res = await updateDspCurrency(dspDetails);
        onUserUpdate(res?.updatedDSP);
        Loading.set(false);
        Popup.alert("SUCCESS", "Currency Updated", "SUCCESS", onClose);
      } catch (e) {
        Loading.set(false);
        Popup.alert(
          "Error",
          e || "something went wrong while changing password.",
          "ERROR",
        );
      }
    }
  };
  return (
    <Modal
      header={"Add Currency"}
      open={open}
      onClose={onClose}
      contentStyle={{ width: "574px", height: "250px" }}
      divider={true}
      headingStyle={{ fontSize: "18px" }}
      iconSize={"18px"}
      headerContainerStyle={{ padding: "20px 40px" }}
    >
      <Form
        onSubmitForm={(data) => {
          if (!dsp?.id) {
            console.log("DSP missing", dsp);
            return;
          }
          const { invoice_currency } = data;
          EditCurrencyData({
            invoice_currency: invoice_currency?.value,
            id: dsp?.id,
          });
        }}
        style={{
          padding: "15px 40px 20px",
          display: "flex",
          flexDirection: "column",
          gap: "1.1rem",
        }}
      >
        {(onSubmit) => (
          <>
            <SelectField
              label={"currency"}
              name={"invoice_currency"}
              placeholder={"select currency"}
              required={false}
              list={currencyList}
              style={{
                height: "51px",
                borderRadius: "8px",
                padding: "2px 15px",
              }}
              inputStyle={{ fontSize: "16px" }}
              // validation={taxPercentageValidation}
              labelStyle={{
                paddingBottom: "7px",
                fontSize: "16px",
                color: "#3b3b3b",
                fontWeight: "400",
              }}
              // defaultValue={currencyList.find((c) => c.value === dsp?.currency)}
              defaultValue={currencyList.find(
                (c) => c.value === dsp?.invoice_currency,
              )}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                gap: "15px",
              }}
            >
              <Button
                type={"submit"}
                text="Update"
                style={{ width: "110px", height: "40px", fontSize: "16px" }}
                onClick={() => onSubmit()}
              />
              <Button
                type={"button"}
                onClick={() => {
                  onClose();
                }}
                text={"Cancel"}
                isBtnNotActive={true}
                style={{ width: "110px", height: "40px", fontSize: "16px" }}
              />
            </div>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default EditCurrency;
